import loadable from '@loadable/component';

export const NotificationPreferencesLoadable = loadable(
  () => import('./NotificationPreferences'),
  {
    resolveComponent: (module) => module.NotificationPreferences,
  },
);
